// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c8nbxd{font:var(--ds-font-heading-small,normal 600 1pc/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._19pkpxbi{margin-top:var(--ds-space-200,1pc)}\n._19pku2gc{margin-top:var(--ds-space-100,8px)}\n._19pkxncg{margin-top:var(--ds-space-800,4pc)}", ""]);
// Exports
module.exports = exports;
